import React from "react";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
// import Fade from "@mui/material/Fade";

export default function ImagePreviewModal(props) {
  const {
    isOpen,
    handleClose,
    imagePreviewSource,
    imagePreviewContentType 
  } = props;

  // imagePreviewSource, imagePreviewContentType 

  return (
    <div>
      <Modal
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        {/* <Fade
          in={open}
          > */}
          <div
            style={{
              width: "80vw",
              height: "100vh",
              background: "black",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "auto",
            }}
          >
            <object
              aria-label="object preview"
              type={imagePreviewContentType}
              data={imagePreviewSource}
              alt={"filename"}
              height={1000}
              width={1000}
            ></object>
          </div>
        {/* </Fade> */}
      </Modal>
    </div>
  );
}
